import { styled } from 'linaria/react';
import React from 'react';
import posed from 'react-pose';
import { RangeSlider } from '../RangeFilters';
import { ActiveCarot } from './ActiveCarot';
import {
  AccordionButton,
  AccordionContentWrapper,
  DrawerSubTitle
} from './ListAccordion';

export const RangeAccordion = ({
  filters,
  accordionProps,
  startingIdx = 0
}) => {
  const rangeFilters = filters.filter(
    filter => filter.__typename === 'NumericRangeFilter'
  );
  if (rangeFilters.length === 0) return null;

  return rangeFilters.map((rangeFilter, idx) => (
    <RangeFilter
      key={rangeFilter.id}
      rangeFilter={rangeFilter}
      idx={idx}
      accordionProps={accordionProps}
      startingIdx={startingIdx}
    ></RangeFilter>
  ));
};

// work around to make children clickable in AccordionContent
const PosedDiv = posed.div({
  opened: {
    height: 'auto'
  },
  closed: {
    height: 0
  }
});

const PosedAccordionItem = styled(PosedDiv)`
  overflow: hidden;
  height: 0;
`;

const AccordionContent = props => (
  <PosedAccordionItem
    pose={props.isOpen ? 'opened' : 'closed'}
    initialPose="closed"
  >
    {props.children}
  </PosedAccordionItem>
);

function RangeFilter({ rangeFilter, idx, accordionProps, startingIdx }) {
  const accordionIsOpen = accordionProps.openIndexes.includes(
    idx + startingIdx
  );

  return (
    <React.Fragment>
      <AccordionButton
        onClick={() => accordionProps.handleClick(idx + startingIdx)}
      >
        <DrawerSubTitle>
          {rangeFilter.name}
          {rangeFilter.isActive && <span className="count">(1)</span>}
        </DrawerSubTitle>
        <ActiveCarot isActive={rangeFilter.isActive} isOpen={accordionIsOpen} />
      </AccordionButton>
      <AccordionContent isOpen={accordionIsOpen}>
        <AccordionContentWrapper>
          <RangeSlider filter={rangeFilter} />
        </AccordionContentWrapper>
      </AccordionContent>
    </React.Fragment>
  );
}
